// import React, { useState } from 'react';
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {addressAndRatingDetails, addressCommentDetails, BusinessAddressVerification, verificationService} from "../../services/rating";
import {getContractorDashboardService} from "../../services/contractorServices";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import CustomRatingStar from "../../CustomComponents/CustomRatingStar";
import {fDate} from "../../utils/format-time";
import {getStatusBadge, getTypeCommentsBadge, truncateWords} from "../../utils/format-text";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import {sweetAlerts} from "../../utils/sweet-alerts";
import {GoogleAddress} from "../GoogleAddress";
import CustomBusinessVerifiedMain from "../../CustomComponents/CustomBusinessVerifiedMain";

const DashboardHome = () => {
	const trusted = localStorage.getItem("trusted");
	const name = localStorage.getItem("first_name") + " " + localStorage.getItem("last_name");

	const [error, setError] = useState("");
	const [queryLink, setQueryLink] = useState("");
	const [verifiedError, setVerifiedError] = useState(null);
	const [showProfileVerificationModal, setShowProfileVerificationModal] = useState(false);

	const [counts, setCounts] = useState({});

	const getData = async () => {
		try {
			const response = await getContractorDashboardService({});
			setCounts(response?.data);
		} catch (error) {}
	};

	useEffect(() => {
		getData();
	}, []);

	const handleChange = (e) => {
		const value = e.target.value;
		setQueryLink(value);

		try {
			new URL(value);
			setError("");
		} catch {
			setError("Please enter a valid URL");
		}
	};

	async function getAutocomplete(query) {
		try {
			setVerifiedError("");

			const verificationBtn = document.getElementById("verification-btn");
			if (verificationBtn) {
				verificationBtn.disabled = true;
				verificationBtn.textContent = "Verifying...";
			}

			const response = await BusinessAddressVerification({address: query});

			if (response.status) {
				setShowProfileVerificationModal(false);
				localStorage.setItem("verified", true);
				setVerifiedError(null);
				window.location.reload();
				sweetAlerts("success", response?.message);
			} else {
				setVerifiedError("We couldn’t verify your business because some of the information doesn’t match our records. Please review and update your personal information in your profile, then try again.");
				if (verificationBtn) {
					verificationBtn.disabled = false;
					verificationBtn.textContent = "Verify";
				}
			}
		} catch (error) {
			setVerifiedError("We couldn’t verify your business because some of the information doesn’t match our records. Please review and update your personal information in your profile, then try again.");
		} finally {
			const verificationBtn = document.getElementById("verification-btn");
			if (verificationBtn) {
				verificationBtn.disabled = false;
				verificationBtn.textContent = "Verify";
			}
		}
	}
	return (
		<div className="dashboard-home">
			{trusted !== "true" && (
				<div
					className="alert alert-warning d-flex verification-alert cursor-pointer"
					onClick={() => {
						setError(null);
						setQueryLink("");
						setShowProfileVerificationModal(true);
					}}>
					<div className="bi-exclamation-circle-fill me-2" />
					Provide your Google Business Listing to receive a “Trusted” badge next to your name.
				</div>
			)}

			<div className="welcome-section d-flex justify-content-between">
				<div>
					<h2>Welcome, {name}!</h2>
					<p>Here's what's happening with your ratings and recommendations.</p>
				</div>
			</div>

			<div className="stats-grid mobile-stats-grid-compact">
				{/* <Link to="/contractor-dashboard/ratings" className="stat-card text-decoration-none">
					<div className="stat-icon stat-icon-primary">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{counts?.totalRating || 0}</div>
						<div className="stat-label">Total Ratings</div>
					</div>
				</Link> */}

				{/* <Link to="/contractor-dashboard/ratings" state={{from: "dashboard", filter: "flagged"}} className="stat-card text-decoration-none"> */}

				<Link to="/contractor-dashboard/flagged" className="stat-card text-decoration-none mobile-stat-card-compact">
					<div className="stat-icon stat-icon-danger">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M10.29 3.86L1.82 18C1.64 18.37 1.54 18.78 1.54 19.2C1.54 19.62 1.64 20.03 1.82 20.4C2 20.77 2.26 21.09 2.59 21.33C2.92 21.57 3.31 21.73 3.72 21.8C4.13 21.87 4.55 21.85 4.95 21.75C5.35 21.65 5.72 21.47 6.04 21.22L12 17.27L17.96 21.22C18.28 21.47 18.65 21.65 19.05 21.75C19.45 21.85 19.87 21.87 20.28 21.8C20.69 21.73 21.08 21.57 21.41 21.33C21.74 21.09 22 20.77 22.18 20.4C22.36 20.03 22.46 19.62 22.46 19.2C22.46 18.78 22.36 18.37 22.18 18L13.71 3.86C13.53 3.49 13.27 3.17 12.94 2.93C12.61 2.69 12.22 2.53 11.81 2.46C11.4 2.39 10.98 2.41 10.58 2.51C10.18 2.61 9.81 2.79 9.49 3.04C9.17 3.29 8.91 3.61 8.73 3.98C8.55 4.35 8.45 4.76 8.45 5.18C8.45 5.6 8.55 6.01 8.73 6.38L10.29 3.86Z"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M12 9V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M12 17H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{counts?.totalFlagged || 0}</div>
						<div className="stat-label">Flagged</div>
					</div>
				</Link>

				{/* </Link> */}

				{/* New Stat Cards */}
				<Link to="/contractor-dashboard/likes" className="stat-card text-decoration-none mobile-stat-card-compact">
					<div className="stat-icon stat-icon-success">
						{/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.04097 1.5487 8.5C1.5487 9.95903 2.1283 11.3583 3.16 12.39L12 21.23L20.84 12.39C21.351 11.8792 21.7564 11.2728 22.0329 10.6054C22.3095 9.93789 22.4518 9.22249 22.4518 8.5C22.4518 7.77751 22.3095 7.0621 22.0329 6.39464C21.7564 5.72718 21.351 5.12075 20.84 4.61Z"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg> */}

						<div className="bi-hand-thumbs-up" style={{fontSize: 20}} />
					</div>

					<div className="stat-content">
						<div className="stat-number">{counts?.totalLike || 0}</div>
						<div className="stat-label">Likes</div>
					</div>
				</Link>

				<Link to="/contractor-dashboard/uplifts" className="stat-card text-decoration-none mobile-stat-card-compact">
					<div className="stat-icon stat-icon-warning">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{counts?.totalUplift || 0}</div>
						<div className="stat-label">Uplifts</div>
					</div>
				</Link>

				<Link to="/contractor-dashboard/comment-history" className="stat-card text-decoration-none mobile-stat-card-compact">
					<div className="stat-icon stat-icon-info">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{counts?.totalReplies || 0}</div>
						{/* <div className="stat-label">Comment History</div> */}
						<div className="stat-label">Replies</div>
					</div>
				</Link>
			</div>

			<div className="quick-actions">
				<h3>Quick Actions</h3>
				<div className="action-buttons">
					<Link to="/contractor-dashboard/submit-rating" className="action-btn action-btn-primary">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 5V19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						Submit New Rating
					</Link>
					<Link to="/contractor-dashboard/ratings" className="action-btn action-btn-secondary">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						View My Ratings
					</Link>
					<Link to="/contractor-dashboard/submit-comment" className="action-btn action-btn-primary">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 5V19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						Submit New Comment
					</Link>
					<Link to="/contractor-dashboard/comments" className="action-btn action-btn-secondary">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						View My Comments
					</Link>
				</div>
			</div>

			<div className="recent-ratings">
				<h3>Recent Ratings</h3>
				<RecentRatings />
				<div className="table-footer">
					<Link to="/contractor-dashboard/ratings" className="view-all-link">
						View All Ratings →
					</Link>
				</div>
			</div>

			<div className="recent-ratings">
				<h3>Recent Comments</h3>
				<RecentComments />
				<div className="table-footer">
					<Link to="/contractor-dashboard/comments" className="view-all-link">
						View All Comments →
					</Link>
				</div>
			</div>

			{showProfileVerificationModal && (
				<div className="modal-overlay" onClick={() => setShowProfileVerificationModal(false)}>
					<div className="modal-content" onClick={(e) => e.stopPropagation()}>
						<div className="modal-header">
							<h3>Business verification</h3>
							<button className="modal-close" onClick={() => setShowProfileVerificationModal(false)}>
								×
							</button>
						</div>

						<div className="m-4">
							<CustomBusinessVerifiedMain cbAction={() => setShowProfileVerificationModal(false)} />
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

const RecentRatings = () => {
	const headCells = [
		{id: "jobsite", label: "Job Site", width: "200px"},
		{id: "hobdate", label: " Date", width: "100px"},
		{id: "status", label: "Status", width: "100px"},
		{id: "rating", label: "Rating", width: "100px"},
	];

	useEffect(() => {
		addressAndRatingDetails({page: 1, pagesize: 5, rating: "all", status: "all", sortby: "date-desc"})
			.then((res) => {
				if (res?.status) {
					setList(res?.data?.list || []);
				}
			})
			.catch(() => {});
	}, []);

	const [list, setList] = useState([]);

	return (
		<Paper sx={{width: "100%", overflow: "hidden"}}>
			<TableContainer>
				<Table aria-labelledby="ratings table" sx={{minWidth: 750}}>
					<TableHead className="">
						<TableRow>
							{headCells.map((headCell) => (
								<TableCell key={headCell.id} sx={{fontWeight: 600, width: headCell.width}}>
									{headCell.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{list.map((row, index) => (
							<TableRow hover key={index}>
								<TableCell>{truncateWords(row?.address?.full_address, 35) || "N/A"}</TableCell>
								<TableCell>{fDate(row?.job_date)} </TableCell>
								<TableCell>
									<Tooltip title={row?.admin_flagged ? "This rating has been flagged by the admin. Please contact the admin for clarification." : ""}>
										{getStatusBadge(row?.is_historic, row?.admin_flagged)}
									</Tooltip>
								</TableCell>
								<TableCell sx={{alignItems: "center"}}>
									<CustomRatingStar star={row?.stars} />
								</TableCell>
							</TableRow>
						))}

						{list.length === 0 && (
							<TableRow>
								<TableCell colSpan={headCells.length}>
									<Typography align="center" sx={{py: 2}}>
										No Recode found
									</Typography>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};

const RecentComments = () => {
	const headCells = [
		{id: "streetzipcode", label: "Street/Zipcode", width: "200px"},
		{id: "comment", label: "Comment", width: "200px"},
		{id: "hobdate", label: "Job Date", width: "100px"},
		{id: "rating", label: "Type", width: "100px"},
		{id: "status", label: "Status", width: "100px"},
	];

	useEffect(() => {
		addressCommentDetails({page: 1, pagesize: 5, rating: "all", status: "all", sortby: "date-desc"})
			.then((res) => {
				if (res?.status) {
					setList(res?.data?.list || []);
				}
			})
			.catch(() => {});
	}, []);

	const [list, setList] = useState([]);

	return (
		<Paper sx={{width: "100%", overflow: "hidden"}}>
			<TableContainer>
				<Table aria-labelledby="comment table" sx={{minWidth: 750}}>
					<TableHead className="">
						<TableRow>
							{headCells.map((headCell) => (
								<TableCell key={headCell.id} sx={{fontWeight: 600, width: headCell.width}}>
									{headCell.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{list.map((row, index) => (
							<TableRow hover key={index}>
								<TableCell>{truncateWords(row?.addresses || "Comment Reply", 30) || "N/A"}</TableCell>
								<TableCell>{truncateWords(row?.description, 35) || "N/A"}</TableCell>
								<TableCell>{fDate(row?.comment_date)} </TableCell>
								<TableCell>{getTypeCommentsBadge(row?.comment_type)} </TableCell>
								<TableCell>
									<Tooltip title={row?.admin_flagged ? "This comment has been flagged by the admin. Please contact the admin for clarification." : ""}>
										{getStatusBadge(row?.is_historic, row?.admin_flagged)}
									</Tooltip>
								</TableCell>
							</TableRow>
						))}

						{list.length === 0 && (
							<TableRow>
								<TableCell colSpan={headCells.length}>
									<Typography align="center" sx={{py: 2}}>
										No Address found
									</Typography>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};

export default DashboardHome;
